import axios from 'axios';
import * as log from 'loglevel';
import * as config from '../app.config';

axios.defaults.headers.common['x-api-key'] = config.apiKey;

/**
 * Get Connection Options for all calls.
 *
 * @param { object } params to retrieve data
 *
 * @returns { object } options
 */
export function getConnectionOptions(params) {
  const url = config.apiUrl + 'connect-options';
  return axios({
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    url: url,
    params: params,
  })
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      log.debug('getConnectionOptions', error);
      throw error;
    });
}

/**
 * Get Personal Connection.
 *
 * @param { object } params from form.
 *
 * @returns { object } options
 */
export function getPersonalConnection(params) {
  const url = config.apiUrl + 'personal-connection';
  return axios({
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    url: url,
    params: params,
  })
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      log.debug('getPersonalConnection', error);
      throw error;
    });
}

/**
 * Get Estimated Wait.
 *
 * @param { object } params to make web service call.
 *
 * @returns { object } options
 */
export function getEstimatedWait(params) {
  const url = config.apiUrl + 'estimated-wait';

  return axios({
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    url: url,
    params: params,
  })
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      log.debug('getEstimatedWait', error);
      throw error;
    });
}
